define( function() {
	return ( /^(?:checkbox|radio)$/i );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/manipulation/var/rcheckableType.js
// module id = 546
// module chunks = 352